import { FaGauge, FaUsers } from "react-icons/fa6";
import { Icon } from '@iconify/react';

export default {
	header: {
		self: {},
		items: [],
	},
	aside: {
		self: {},
		items: [
			{
				title: "Dashboard",
				root: true,
				iconComponent: <Icon icon="solar:graph-bold-duotone" width="24" />,
				page: "dashboard",
				bullet: "dot",
			},
			{
				title: "Desafios",
				root: true,
				iconComponent:  <Icon icon="solar:cup-star-bold-duotone" width="24" />,
				page: "desafios",
				bullet: "dot",
			},
			{
				title: "Setores",
				root: true,
				iconComponent:  <Icon icon="solar:widget-bold-duotone" width="24" />,
				page: "setores",
				bullet: "dot",
			},
			{
				title: "Colaboradores",
				root: true,
				iconComponent:  <Icon icon="solar:users-group-two-rounded-bold-duotone" width="24" />,
				page: "colaboradores",
				bullet: "dot",
			},
			{
				title: "Configurações",
				root: true,
				iconComponent:  <Icon icon="solar:settings-bold-duotone" width="24" />,
				page: "configuracoes",
				bullet: "dot",
			},
		],
	},
};
